import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { type OptimisticUiMeta, beginOptimisticUiMeta } from '../../meta/optimistic-ui-meta.tsx';

export const SPRINT_BOARD_LINK_CLICK = 'state.actions.sprints.board-link-click' as const;
export const SPRINT_BOARD_LINK_CLICK_PERMISSIONLESS =
	'state.actions.sprints.board-link-click.permissionless-flag' as const;
export const SPRINT_BOARD_LINK_CLICK_SUCCESS =
	'state.actions.sprints.board-link-click.success' as const;
export const SPRINT_BOARD_LINK_CLICK_FAILURE =
	'state.actions.sprints.board-link-click.failure' as const;

export type SprintBoardlinkClickAction = {
	type: typeof SPRINT_BOARD_LINK_CLICK;
	payload: {
		rapidViewId: number;
	};
	meta: OptimisticUiMeta & { analyticsEvent: UIAnalyticsEvent };
};

export type SprintBoardlinkClickSuccess = {
	type: typeof SPRINT_BOARD_LINK_CLICK_SUCCESS;
	payload: {};
	meta: OptimisticUiMeta;
};

export type SprintBoardlinkClickFailure = {
	type: typeof SPRINT_BOARD_LINK_CLICK_FAILURE;
	payload: {};
	meta: OptimisticUiMeta;
};

export type SprintBoardlinkClickPermissionlessFlagAction = {
	type: typeof SPRINT_BOARD_LINK_CLICK_PERMISSIONLESS;
	payload: {};
	meta: OptimisticUiMeta & { analyticsEvent: UIAnalyticsEvent };
};

export const sprintBoardLinkPermissionlessFlagRequest = (
	analyticsEvent: UIAnalyticsEvent,
): SprintBoardlinkClickPermissionlessFlagAction => ({
	type: SPRINT_BOARD_LINK_CLICK_PERMISSIONLESS,
	payload: {},
	meta: {
		...beginOptimisticUiMeta(),
		analyticsEvent,
	},
});

export const sprintBoardLinkClickRequest = (
	rapidViewId: number,
	analyticsEvent: UIAnalyticsEvent,
): SprintBoardlinkClickAction => ({
	type: SPRINT_BOARD_LINK_CLICK,
	payload: {
		rapidViewId,
	},
	meta: {
		...beginOptimisticUiMeta(),
		analyticsEvent,
	},
});

export const sprintBoardLinkClickSuccess = (
	analyticsEvent: UIAnalyticsEvent,
): SprintBoardlinkClickSuccess => ({
	type: SPRINT_BOARD_LINK_CLICK_SUCCESS,
	payload: {},
	meta: {
		...beginOptimisticUiMeta(),
		analyticsEvent,
	},
});

export const sprintBoardLinkClickFailure = (
	analyticsEvent: UIAnalyticsEvent,
): SprintBoardlinkClickFailure => ({
	type: SPRINT_BOARD_LINK_CLICK_FAILURE,
	payload: {},
	meta: {
		...beginOptimisticUiMeta(),
		analyticsEvent,
	},
});

export type Action =
	| SprintBoardlinkClickAction
	| SprintBoardlinkClickPermissionlessFlagAction
	| SprintBoardlinkClickSuccess
	| SprintBoardlinkClickFailure;
